import { useCallback, useEffect, useState } from 'react'

type CustomerGroup = {
  id: string
  name: string
  description?: string
}

export const getCustomerGroups = async () => {
  const request = await fetch('/api/account/get-customer-groups', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  const response = await request.json()
  return response.data
}

const useGetCustomerGroups = () => {
  const [customerGroups, setCustomerGroups] = useState<CustomerGroup[]>()

  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const fetchCustomerGroups = useCallback(async () => {
    setLoading(true)
    try {
      const request = await fetch('/api/account/get-customer-groups', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const response = await request.json()

      const customerGroups = response.data
        .sort((a: CustomerGroup, b: CustomerGroup) => a.id.localeCompare(b.id))
        .filter(
          (g: CustomerGroup) => g.id !== 'cusgrp_01k47a6axkeqrt710ybzmcbxqe',
        ) // Exclude AD 35% group

      setCustomerGroups(customerGroups)
    } catch (err) {
      setError('Failed to fetch customer groups')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchCustomerGroups()
  }, [fetchCustomerGroups])

  return { customerGroups, loading, error, refetch: fetchCustomerGroups }
}

export default useGetCustomerGroups
